import React from 'react'
import clsx from 'clsx'
import { Box, Typography } from '@mui/material'
import { Badge } from 'src/components/atoms'
import {
  getReportStatusBadgeColor,
  getReportStatusFillTypeColor,
  getReportStatusTitle,
} from 'src/domain/reportStatus'
import { ReportStatusEnum, Tenant } from 'src/slices/services/api'
import styles from './styles.module.scss'

export type TenantNameProps = {
  tenant?: Tenant
  reportStatus?: ReportStatusEnum
} & React.StyledProps

const TenantName: React.StyledFC<TenantNameProps> = ({
  className,
  tenant,
  reportStatus,
}: TenantNameProps) => {
  return (
    <Box className={clsx(className, styles.tenantTypography)}>
      {reportStatus && (
        <Badge
          className={styles.badge}
          label={getReportStatusTitle(reportStatus)}
          color={getReportStatusBadgeColor(reportStatus)}
          fillType={getReportStatusFillTypeColor(reportStatus)}
          ellipse
        />
      )}
      <Typography className={styles.code}>{tenant?.code}</Typography>
      <Typography className={styles.name}>{tenant?.name}</Typography>
    </Box>
  )
}

export default TenantName
